module.exports = __webpack_public_path__ + "img/ui-project-2.f5085c43.jpg";